import { Component, OnInit } from '@angular/core'
import { MatProgressBar } from '@angular/material/progress-bar'
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component'
import { TableListComponent } from '../../../shared/components/table-list/table-list.component'
import { AuthService } from '../../../core/services/auth/auth.service'
import { MatDialog } from '@angular/material/dialog'
import {
  PagedContactTypeResponse,
  SearchContactTypeModel,
} from '../../../core/models/contact-type.model'
import { FormSearchComponent } from '../../../shared/components/form-search/form-search.component'
import { MatButton } from '@angular/material/button'
import { HealthUnitService } from '../../../core/services/health-unit/location/health-unit.service'
import { HealthUnitCreateComponent } from '../../../features/health-unit/health-unit-create/health-unit-create.component'
import { HealthUnitEditComponent } from '../../../features/health-unit/health-unit-edit/health-unit-edit.component'
import { MatPaginatorModule } from '@angular/material/paginator'
import { PageEvent } from '@angular/material/paginator'
import {
  MedicalInsuranceCreateComponent
} from '../../../features/medical-insurance/location-create/medical-insurance-create.component';
import {
  MedicalInsuranceEditComponent
} from '../../../features/medical-insurance/location-edit/medical-insurance-edit.component';
import {MedicalInsuranceService} from '../../../core/services/medical-insurance/municipality/medical-insurance.service';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatOption} from '@angular/material/core';
import {MatSelect} from '@angular/material/select';
import {MatIcon} from '@angular/material/icon';
@Component({
  selector: 'medical-insurance',
  imports: [
    MatProgressBar,
    TableListComponent,
    MatButton,
    MatPaginatorModule,
    FormsModule,
    MatFormField,
    MatLabel,
    MatOption,
    MatSelect,
    ReactiveFormsModule,
    MatIcon,
  ],
  templateUrl: './medical-insurance.component.html',
  styleUrl: './medical-insurance.component.scss',
  providers: [HealthUnitService, AuthService],
  standalone: true,
})
export class MedicalInsuranceComponent implements OnInit {
  constructor(
    private locationService: MedicalInsuranceService,
    private authService: AuthService,
    private dialog: MatDialog,
    private formBuilder: FormBuilder,

  ) {}
  form!: FormGroup

  page: number = 1
  rows: number = 10
  numberRows: number = 0
  itemsList: any[] = []
  loading: boolean = false
  searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  inputSearch: string = ''
  columns: any[] = [
    {
      keyColumn: 'id',
      key: 'id',
      description: 'Código',
    },
    {
      keyColumn: 'descricao',
      key: 'descricao',
      description: 'Descrição',
    },
    {
      keyColumn: 'ativo',
      key: 'status_id',
      description: 'Ativo',
    },
    {
      keyColumn: 'action',
      key: { edit: false, delete: false },
      description: 'Ações',
    },
  ]
  screen: string = 'convenio'

  ngOnInit() {
    this.checkColumnAction()
    this.getListItems()
    this.createForm()

  }
  createForm() {
    this.form = this.formBuilder.group({
      status: [null],
    })
  }
  status_id: number | null = null
  onChange() {
    this.status_id = this.form.get('status')?.value
    this.page = 1
    this.getListItems()
  }
  checkColumnAction() {
    let index = this.columns.findIndex((ele: any) => {
      return ele.keyColumn == 'action'
    })
    if (index != -1) {
      this.columns[index].key = {
        edit: this.checkPermission('editar'),
        delete: this.checkPermission('excluir'),
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }

  search(event: any) {
    let search = event
    this.page = 1
    if (search) {
      this.searchForm.descricao = search
      // this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  pageChanged(page: number) {
    this.page = page
    this.uploadList()
  }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1 // pageIndex é zero-based, a sua variável page é 1-based
    this.rows = event.pageSize
    this.uploadList()
  }

  pageSizeChanged(newPageSize: number) {
    this.rows = newPageSize
    this.page = 1 // normalmente reseta para a primeira página
    this.uploadList()
  }

  uploadList(type: string = '') {
      this.status_id = null
      this.form.get("status")?.setValue(null)
      this.getListItems()
  }

  treatResponse(response: any) {
    let list = []
    if (response.data) {
      for (let item of response.data) {
        list.push(item)
      }
    }
    this.itemsList = list
    this.numberRows = response.paging.total
  }

  // getListItems() {
  //   this.loading = true
  //   this.locationService.listPagedLocation(this.page, this.rows).subscribe({
  //     next: (response: any) => {
  //       this.treatResponse(response)
  //     },
  //     error: (err: PagedContactTypeResponse) => {},
  //     complete: () => {
  //       this.loading = false
  //     },
  //   })
  // }
  getListItems() {
    this.loading = true
    this.locationService.listPagedMedInsurances(this.page,this.rows, this.status_id).subscribe({
      next: (response: any) => {
        this.treatResponse(response)
      },
      error: (err: PagedContactTypeResponse) => {},
      complete: () => {
        this.loading = false
      },
  })}

  // searchListItems() {
  //   this.loading = true
  //   this.locationService
  //     .searchMunicipality(this.page, this.rows, this.searchForm)
  //     .subscribe({
  //       next: (response: any) => {
  //         this.treatResponse(response)
  //       },
  //       error: (err: PagedContactTypeResponse) => {},
  //       complete: () => {
  //         this.loading = false
  //       },
  //     })
  // }

  newEmployee() {
    const dialogRef = this.dialog.open(MedicalInsuranceCreateComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '950px',
      // height: '100vh',
    })
    dialogRef.componentInstance.responseCreate.subscribe((response) => {
      this.uploadList()
    })
  }

  editItem(item: any) {
    const dialogRef = this.dialog.open(MedicalInsuranceEditComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '950px',
      // height: '100vh',
      data: { item },
    })
    dialogRef.componentInstance.responseEdit.subscribe((response) => {
      this.uploadList()
    })
  }

  deleteItem(item: any) {
    this.loading = true
      this.locationService.inactivateMedInsurance(item.id).subscribe({
        next: (response: any) => {
          this.getListItems()
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
    }
}
